<div class="input-container">
  @if (label()) {
    <div [innerHtml]="label()" class="label"></div>
  }
  <div class="input-wrapper">
    @if (icon() && iconPos() === 'left') {
      <div class="icon">
        <u-icon class="input-icon input-icon-left" [model]="icon()" [styles]="{ height: '16px', width: '16px' }"></u-icon>
      </div>
    }

    @if (styleType() === 'group' && groupContent()) {
      <div class="input-group" [class.focus]="isFocused() && stateElement() !== 'readonly'" [class.error]="hasError()">
        <span class="input-group-content {{ sizeElement() }}" [style]="styles()">
          @if (groupText()) {
            <p class="input-group-text {{ sizeElement() }}">{{ groupText() }}</p>
          }
          @if (groupIcon()) {
            <u-icon class="input-group-icon {{ sizeElement() }}" [model]="groupIcon()"> </u-icon>
          }
        </span>
        <ng-container *ngTemplateOutlet="inputTemplate"></ng-container>
      </div>
    } @else {
      <ng-container *ngTemplateOutlet="inputTemplate"></ng-container>
    }

    <ng-content></ng-content>
    <div class="icon icon-right">
      @switch (rightIconToShow()) {
        @case ('loading') {
          <u-icon class="input-icon input-icon-right" [model]="{ type: 'font', value: 'u-spin icon-spinner' }"></u-icon>
        }
        @case ('copy') {
          <u-icon
            #rightIconTooltip
            class="input-icon input-icon-right"
            [model]="{ type: 'font', value: 'icon-duplicate' }"
            (click)="onCopyEvent()"
            tooltipPosition="bottom"
            [pTooltip]="copyText()"
            tooltipStyleClass="u-tooltip"
          ></u-icon>
        }
        @case ('clear') {
          <u-icon
            class="input-icon input-icon-right input-clear-icon"
            [model]="{ type: 'font', value: 'pi pi-times clear-icon' }"
            [styles]="{
              height: '10px',
              width: '10px',
            }"
            tooltipPosition="bottom"
            [pTooltip]="'Clear'"
            tooltipStyleClass="u-tooltip"
            (click)="onClearEvent($event)"
            (mousedown)="onClearEvent($event)"
          ></u-icon>
        }
        @case ('regular') {
          <u-icon
            #rightIconTooltip
            class="input-icon input-icon-right"
            [model]="icon()"
            (click)="onRightIconClickEvent($event)"
            tooltipPosition="bottom"
            [pTooltip]="tooltipRightIcon()"
            tooltipStyleClass="u-tooltip"
          ></u-icon>
        }
      }
    </div>
  </div>
  @if (currentErrorText()) {
    <div class="error-text">{{ currentErrorText() }}</div>
  }
</div>

<ng-template #inputTemplate>
  @if (formControl(); as control) {
    <input
      [formControl]="control"
      #input
      class="u-input {{ styleClass() }}"
      [attr.data-clear-behavior]="clearIconBehavior()"
      [attr.data-editing-highlight]="editingHighlight()"
      [placeholder]="placeholder()"
      [attr.maxLength]="maxLength() ?? null"
      [style]="styles()"
      [disabled]="stateElement() === 'disabled'"
      [readonly]="stateElement() === 'readonly'"
      [pTooltip]="inputTooltipText()"
      [tooltipPosition]="positionOverflowTooltip()"
      tooltipStyleClass="u-tooltip"
      autoFitWidth
      [autoFitWidthMin]="autoFitWidthMin()"
      [autoFitWidthMax]="autoFitWidthMax()"
      [autoFitWidthEnabled]="autoFitWidthEnabled()"
      (input)="onChangeEvent(control.value)"
      (focus)="onFocusEvent()"
      (blur)="onBlurEvent()"
      (keydown)="onKeydownEvent($event)"
      (mouseenter)="updateTooltipOnHover()"
      [type]="inputType()"
    />
  } @else {
    <input
      #input
      class="u-input {{ styleClass() }}"
      [attr.data-clear-behavior]="clearIconBehavior()"
      [attr.data-editing-highlight]="editingHighlight()"
      [placeholder]="placeholder()"
      [attr.maxLength]="maxLength() ?? null"
      [style]="styles()"
      [disabled]="stateElement() === 'disabled'"
      [readonly]="stateElement() === 'readonly'"
      [ngModel]="model()"
      [pTooltip]="inputTooltipText()"
      [tooltipPosition]="positionOverflowTooltip()"
      tooltipStyleClass="u-tooltip"
      autoFitWidth
      [autoFitWidthMin]="autoFitWidthMin()"
      [autoFitWidthMax]="autoFitWidthMax()"
      [autoFitWidthEnabled]="autoFitWidthEnabled()"
      (ngModelChange)="onChangeEvent($event)"
      (focus)="onFocusEvent()"
      (blur)="onBlurEvent()"
      (keydown)="onKeydownEvent($event)"
      (mouseenter)="updateTooltipOnHover()"
    />
  }
</ng-template>
